// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
